module.exports = __webpack_public_path__ + "img/astana-hub-logo.e77717bf.png";